"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MultiSelectOption = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _useTheme = require("../../../../theme/utils/useTheme");
var _typography = require("../../../typography");
var _selectV2Theme = require("../selectV2Theme");
var _OptionBase = require("../shared/OptionBase");
var _MultiSelectCheckbox = require("./MultiSelectCheckbox");
const MultiSelectOption = /*#__PURE__*/(0, _react.forwardRef)((_ref, ref) => {
  let {
    children,
    checkedState,
    ...props
  } = _ref;
  const {
    key
  } = (0, _useTheme.useTheme)();
  const themeMode = key;
  return /*#__PURE__*/_react.default.createElement(_OptionBase.OptionBase, (0, _extends2.default)({
    ref: ref
  }, props), /*#__PURE__*/_react.default.createElement(_MultiSelectCheckbox.MultiSelectCheckbox, {
    checkedState: checkedState,
    "aria-disabled": props.isDisabled
  }), /*#__PURE__*/_react.default.createElement(_typography.TypeRampV2, {
    lineClamp: 1,
    variant: _selectV2Theme.optionFontTheme.variant(themeMode),
    style: {
      color: "inherit"
    }
  }, children));
});
exports.MultiSelectOption = MultiSelectOption;
MultiSelectOption.displayName = "MultiSelectOption";
//# sourceMappingURL=MultiSelectOption.js.map